var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ViewComponent } from '../view/view.component';
import { ContentBaseService } from '../base/contentbase.service';
var InquiryComponent = /** @class */ (function (_super) {
    __extends(InquiryComponent, _super);
    function InquiryComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.recs = [];
        _this.toggles = [];
        return _this;
    }
    InquiryComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    InquiryComponent.prototype.setUnsubscribe = function () {
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    InquiryComponent.prototype.onSubscribe = function (data) {
        this.recs = [];
        if (typeof data !== 'undefined') {
            this.recs = data.items;
        }
        this.setToggle(false);
        this.toggles[this.recs.length - 1] = true;
        this.rec = {};
        _super.prototype.setCompRec.call(this);
    };
    InquiryComponent.prototype.onEventSubscribe = function (e) {
        var reg = new RegExp('^' + this.componentName + '#Button#quote(\\d+)$');
        if (e.match(reg)) {
            var index = parseInt(RegExp.$1);
            var content = this.recs[index]['content'] || '';
            var line = content.split('\n');
            var retString = '';
            for (var i = 0; i < line.length; i++) {
                if (i !== line.length - 1 || line[i].length !== 0) {
                    retString += '> ' + line[i] + '\n';
                }
            }
            if (this.cols.length > 0) {
                _super.prototype.onChange.call(this, { key: this.cols[0].key, val: retString });
            }
        }
    };
    InquiryComponent.prototype.onEvent = function (e1, e2, rec) {
        if (e2 === 'open') {
            this.setToggle(true);
        }
        else if (e2 === 'close') {
            this.setToggle(false);
        }
        else if (e2 === 'toggle') {
            this.toggles[rec] = !this.toggles[rec];
        }
    };
    InquiryComponent.prototype.setToggle = function (flg) {
        for (var i = 0; i < this.recs.length; i++) {
            this.toggles[i] = flg;
        }
    };
    InquiryComponent.prototype.trackByRec = function (index, rec) {
        return rec.id;
    };
    InquiryComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'inquiry',
                    template: "<div id=\"{{ componentName }}\">\n  <a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'open', '')\">{{ (msg | async)['InquiryComponent.label.openAll'] }}</a>\n  <a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'close', '')\">{{ (msg | async)['InquiryComponent.label.closeAll'] }}</a>\n  <div class=\"-mt-1\">\n    <div *ngFor=\"let r of recs; let index = index; trackBy: trackByRec\" class=\"accordion\">\n      <div class=\"accordion_header\" (click)=\"onEvent($event, 'toggle', index)\">\n        <div class=\"row\">\n          <div class=\"col-sm-2\">\n            <column-formlabel [col]=\"{controlType: 'text'}\" [val]=\"r.xukind_name\"></column-formlabel>\n          </div>\n          <div class=\"col-sm-5\">\n            <column-formlabel [col]=\"{controlType: 'text'}\" [val]=\"r.name\"></column-formlabel>\n          </div>\n          <div class=\"col-sm-5 -txtalnright\">\n            <column-formlabel [col]=\"{controlType: 'datetime'}\" [val]=\"r.cdate\"></column-formlabel>\n          </div>\n        </div>\n      </div>\n      <div class=\"accordion_content\" [hidden]=\"!toggles[index]\">\n        <div class=\"row\">\n          <div class=\"col-sm-12\">\n            <dl class=\"form\">\n              <dt></dt>\n              <dd class=\"form_dd\">\n                <ul>\n                  <li class=\"form_li form_li-w100per\">\n                    <column-formreadonly [col]=\"{controlType: 'textarea'}\" [val]=\"r.content\" [msg]=\"(msg | async)\"></column-formreadonly>\n                  </li>\n                </ul>\n              </dd>\n            </dl>\n          </div>\n        </div>\n        <div class=\"row -mt-2\">\n          <div class=\"col-sm-12\">\n            <btn [componentName]=\"componentName + '#Button'\"\n                 [component]=\"{\n                    params: {\n                      buttons: [{\n                        type: 'button',\n                        event: componentName + '#Button#quote' + index,\n                        caption: (msg | async)['InquiryComponent.button.quote']\n                      }]\n                    }\n                 }\"></btn>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <form>\n    <div *ngIf=\"cols.length > 0\" class=\"row -mt-3\">\n      <div class=\"col-sm-12\">\n        <column [componentName]=\"componentName\" [key]=\"'form'\" [col]=\"cols[0]\" [val]=\"rec\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n      </div>\n    </div>\n  </form>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    InquiryComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ContentBaseService }
    ]; };
    return InquiryComponent;
}(ViewComponent));
export { InquiryComponent };
//# sourceMappingURL=inquiry.component.js.map